<template>
  <Widget
    showCompare
    widgetName="rev-trends"
    @compareClick="handleCompareClick"
    @dataFetched="handleDataFetched"
  >
    <template v-slot:content>
      <div
        class="d-flex justify-center align-center h-100 px-12 pt-6"
        :class="{ 'flex-column': $vuetify.breakpoint.xs }"
      >
        <Trend
          type="created"
          :globalAverage="createdGlobalAverage"
          :title="$t('common.created')"
          :total="createdTotalBySite"
          :percentageChange="createdPercentageChangeBySite"
          :totalLastPeriod="createdTotalBySiteLastPeriod"
          :showComparation="showComparation"
        />
        <div class="mx-6 pb-5 h-100">
          <v-divider vertical v-if="!$vuetify.breakpoint.xs" />
        </div>
        <Trend
          type="completed"
          :globalAverage="completedGlobalAverage"
          :title="$t('common.completed')"
          :total="completedTotalBySite"
          :percentageChange="completedPercentageChangeBySite"
          :totalLastPeriod="completedTotalBySiteLastPeriod"
          :showComparation="showComparation"
        />
      </div>
    </template>
  </Widget>
</template>

<script>
import Widget from './SharedComponents/WidgetBase.vue'
import Trend from './SharedComponents/ContentTrend.vue'
import mixin from '@/mixins/mixin.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'RevTrends',

  mixins: [mixin],

  components: {
    Widget,
    Trend,
  },

  data() {
    return {
      showComparation: false,
      compareData: {},
      widget: {},
    }
  },

  computed: {
    ...mapGetters(['organization']),

    createdGlobalAverage() {
      return Number(this.compareData?.data?.created?.revs?.globalAverage ?? 0)
    },

    completedGlobalAverage() {
      return Number(this.compareData?.data?.completed?.revs?.globalAverage ?? 0)
    },

    createdTotalBySite() {
      return {
        text: this.formatNumber(this.widget?.data?.created?.revs?.total),
        value: Number(this.widget?.data?.created?.revs?.total ?? 0),
      }
    },

    createdTotalBySiteLastPeriod() {
      return Number(this.widget?.data?.created?.revs?.totalLastPeriod ?? 0)
    },

    createdPercentageChangeBySite() {
      return Number(this.widget?.data?.created?.revs?.percentageChange ?? 0)
    },

    completedTotalBySite() {
      return {
        text: this.formatNumber(this.widget?.data?.completed?.revs?.total),
        value: Number(this.widget?.data?.completed?.revs?.total ?? 0),
      }
    },

    completedTotalBySiteLastPeriod() {
      return Number(this.widget?.data?.completed?.revs?.totalLastPeriod ?? 0)
    },

    completedPercentageChangeBySite() {
      return Number(this.widget?.data?.completed?.revs?.percentageChange ?? 0)
    },
  },

  methods: {
    handleCompareClick(comparing, data) {
      this.showComparation = comparing
      if (data) {
        this.compareData = data
      }
    },

    handleDataFetched(data) {
      this.widget = { ...data }
    },

    formatNumber(value) {
      const abreviatedValue = Intl.NumberFormat('en-us', {
        notation: 'compact',
        maximumFractionDigits: 1,
      }).format(value)
      return abreviatedValue
    },
  },
}
</script>
